module.exports = __webpack_public_path__ + "a573941f02f4331f81046356ebb667eb.swf";


//////////////////
// WEBPACK FOOTER
// ./bower_components/zeroclipboard/dist/ZeroClipboard.swf
// module id = 623
// module chunks = 0